<div id="dashboard" class="h-full w-full flex justify-center items-center">
    <mat-tab-group class="h-full w-full" animationDuration="0ms" dynamicHeight mat-stretch-tabs>
        <mat-tab [label]="address1">
            <ng-template matTabContent class="h-full" style="height: 100vh !important">
                <mat-progress-spinner *ngIf="loadingIFrame1" mode="indeterminate" style="margin: 10px auto">
                </mat-progress-spinner>
                <iframe *ngIf="iframeUrl1" (unload)="iframe1Unloaded()" (load)="iframe1Loaded()" [src]="iframeUrl1"
                    class="h-full w-screen sm:w-98" style="height: 100vh !important"></iframe>
            </ng-template>
        </mat-tab>
        <mat-tab [label]="address2" *ngIf="address2 != ''">
            <ng-template matTabContent class="h-full">
                <mat-progress-spinner *ngIf="loadingIFrame2" mode="indeterminate" style="margin: 10px auto">
                </mat-progress-spinner>
                <iframe *ngIf="iframeUrl2" (unload)="iframe2Unloaded()" (load)="iframe2Loaded()" [src]="iframeUrl2"
                    class="h-full w-screen sm:w-98" style="height: 100vh !important"></iframe>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>